const e = {
  id: "MassachusettsMegabucks",
  logo: !0,
  name: "Megabucks",
  style: {
    colorPrimary: "#ec1e24"
  }
};
export {
  e as default
};
